<template>
	<div>
		<transition appear name="fadeslow">
			<div class="slider-buttons-wrapper">
				<div class="slider-buttons">
					<div class="text-button-wrapper transition-center">
						<span @click="prev"> &lt; </span>
					</div>

					<div v-if="animate" @click="pause">
						<PauseIcon class="svg-wrapper transition-center"/>
					</div>
					<div v-if="!animate" @click="play">
						<PlayIcon class="svg-wrapper transition-center"/>
					</div>

					<div class="text-button-wrapper transition-center">
						<span @click="next"> &gt; </span>
					</div>
				</div>
			</div>
		</transition>

		<div class="image-wrapper">
			<transition-group name='fade' tag='div'>
				<div v-for="number in [currentNumber]" :key='number'>
					<img v-if="currentImage.alignment=='center'" class="img-center" :src="currentImage.image">
					<img v-if="currentImage.alignment=='bottom'" class="img-bottom" :src="currentImage.image">
					<img v-if="currentImage.alignment=='top'" class="img-top" :src="currentImage.image">
					<img v-if="currentImage.alignment=='left'" class="img-left" :src="currentImage.image">
					<img v-if="currentImage.alignment=='right'" class="img-right" :src="currentImage.image">
				</div>
			</transition-group>
		</div>

<!--
		<transition-group name='fade' tag='div'>
			<div v-for="number in [currentNumber]"
				:key='number'>
				<img	:src="currentImage"
						v-on:mouseover="pause"
						v-on:mouseout="play" />
			</div>
		</transition-group>
		-->
	</div>
</template>

<script>

	import PauseIcon from "../icons/PauseIcon.vue";
	import PlayIcon from "../icons/PlayIcon.vue";

	export default {
		name: "ImageSlider",
		components: {
			PauseIcon,
			PlayIcon
		},
		data() {
			return {
				images: [
							{ image:require("../assets/_MG_8922.jpg"), alignment:"center" },
							{ image:require("../assets/_DSC2330-Edit.jpg"), alignment:"center" },
							{ image:require("../assets/CRW_1469.jpg"), alignment:"top" },
							{ image:require("../assets/_MG_4577.jpg"), alignment:"center" },
							{ image:require("../assets/CRW_1453.jpg"), alignment:"right" },
							{ image:require("../assets/_MG_0048.jpg"), alignment:"center" },
							{ image:require("../assets/_MG_2767.jpg"), alignment:"center" },
							{ image:require("../assets/_MG_4323.jpg"), alignment:"center" },
							{ image:require("../assets/_MG_3255.jpg"), alignment:"center" },
							{ image:require("../assets/_F5T0545.jpg"), alignment:"center" },
							{ image:require("../assets/_DSC1349.jpg"), alignment:"top" }
							],
				currentNumber: 0,
				timer: null,
				animate: false,
				delay: 2500
			}
		},
		mounted: function () {
			this.startAnimation();
		},
		methods: {
			startAnimation: function() {
				this.timer = setInterval(this.next, this.delay);
				this.animate = true;
			},
			play: function() {
				this.next();
				this.startAnimation();
			},
			pause: function() {
				clearTimeout(this.timer);
				this.timer = null;
				this.animate = false;
			},
			next: function() {
				this.currentNumber += 1
			},
			prev: function() {
				this.currentNumber -= 1
			}
		},
		computed: {
			currentImage: function() {
				return this.images[Math.abs(this.currentNumber) % this.images.length];
			}
		}
	}

</script>

<style scoped>

	.slider-buttons-wrapper {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 1.3rem;
		z-index: 2;		
	}

	.slider-buttons {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
	}

	.text-button-wrapper {
		margin: 0 1rem;
		cursor: default;
		font-size: 1.35rem;
		align-items: center;
	}

	.text-button-wrapper:hover {
		transform: scale(1.6);
	}

/* SVG veritcal alignment Needs fixing
background: #8af;
*/

	.svg-wrapper {
		padding-top: 0.5rem;
	}

	.svg-wrapper:hover {
		transform: scale(1.4);
	}

	.transition-center {
		transition: all 0.3s;
		transform-origin: 50% 50%;
	}

	.image-wrapper {
		position: relative;
		overflow: hidden;
		width: 100vw;
		height: 100vh;
	}

	.img-center {
		position: absolute;
		top: -9999px;
		right: -9999px;
		left: -9999px;
		bottom: -9999px;
		margin: auto;
		min-width: 100%;
		min-height: 100%;
		backface-visibility: hidden
	}

	.img-top {
		position: absolute;
		top: 0;
		right: -9999px;
		left: -9999px;
		bottom: auto;
		margin: auto;
		min-width: 100%;
		min-height: 100%;
		backface-visibility: hidden
	}

	.img-bottom {
		position: absolute;
		top: auto;
		right: -9999px;
		left: -9999px;
		bottom: 0;
		margin: auto;
		min-width: 100%;
		min-height: 100%;
		backface-visibility: hidden
	}

	.img-left {
		position: absolute;
		top: -9999px;
		right: auto;
		left: 0;
		bottom: -9999px;
		margin: auto;
		min-width: 100%;
		min-height: 100%;
		backface-visibility: hidden
	}

	.img-right {
		position: absolute;
		top: -9999px;
		right: 0;
		left: auto;
		bottom: -9999px;
		margin: auto;
		min-width: 100%;
		min-height: 100%;
		backface-visibility: hidden
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 1.4s ease;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

</style>




// WEBPACK FOOTER //
// src/components/ImageSlider.vue